export const cutSlashFromTheEnd = (word: string): string =>
    word.endsWith('/') ? word.slice(0, word.length - 1) : word;
